<template>
    <div class="modal fade modal2" id="file_share_modal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
            <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Transformar</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <select v-model="conversion_group_id" class="form-select form-select-sm mb-3 " aria-label=".form-select-sm example">
                    <option selected="true" >Selecionar Tipo</option>
                    <template v-for="group of conversion_groups" :key="group.id" @change="filter_options(group)">
                        <option :value="group.id">{{group.name}}</option>
                    </template>
                </select>
                <select v-model="conversion_format" class="form-select form-select-lg mb-3" aria-label=".form-select-lg example">
                    <option value="conversion">-</option>
                    <template v-for="conversion of conversion_options.options" :key="conversion" >
                        <option :value="conversion">{{conversion}}</option>
                    </template>
                </select>
                <div class="col-md-12">
                    <button @click="transform()" type="button" class="btn btn-success">Transformar</button>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
            </div>
            </div>
        </div>
    </div>
</template>
<script>
import { Modal } from 'bootstrap'
  export default {
    name: 'FileConversion',
    emits: ['closeModal'],
    props: {
        projectId: {type: Number, default: 0},
        folderId: {type: Number, default: 0},
        fileId: {type: Number, default: 0},
        folderFileId: {type: Number, default: 0},
    },
    data(){
      return {
        modal: null,
        conversion_group_id: null,
        conversion_format: null,
        conversions: null,
        conversion_groups: null,
        conversion_options: {options: null}
      }
    },
    mounted(){
        let app = this
        this.modal = new Modal(document.getElementById('file_share_modal'), {})
        this.modal.show()
        document.getElementById('file_share_modal').addEventListener('hide.bs.modal', function () {
            app.$emit('closeModal')
        })
        this.get_conversions()
    },
    methods:{
        filter_options(group){
            this.conversion_options = this.conversions.find(conv => conv.conversion_group_id == group.id)
        },
        transform(){
           this.axios.post(`projects/${this.projectId}/folders/${this.folderId}/files/${this.fileId}/convert`, {conversion_group_id: this.conversion_group_id, conversion_format: this.conversion_format}).then(result => {
                console.log(result)
                this.$swal({
                    icon: 'success',
                    title: '¡Archivo enviado a transformación!'})
            }).catch(error => {
                console.log(error)
                this.$swal({
                    icon: 'error',
                    title: 'Ops! hubo un problema obteniendo el enlace, favor chequea los datos ingresados o intenta más tarde'})
            })
        },
        get_conversions(){
            this.axios.get(`projects/${this.projectId}/folders/${this.folderId}/files/${this.fileId}/get_conversion_types`).then(result => {
                this.conversions = result.data.body.conversions
                this.conversion_groups = result.data.body.conversion_groups
                this.filter_options(result.data.body.conversion_groups[0])
                console.log(result)
            }).catch(error => {
                console.log(error)
                this.$swal({
                    icon: 'error',
                    title: 'Ops! hubo un problema obteniendo el enlace, favor chequea los datos ingresados o intenta más tarde'})
            })
        },
    },
    computed:{

    }
  }
</script>
<style >
#modal2 {
    z-index: 2000; 
}
.margin-top-20{
    margin-top: 20px;
}
</style>